import Layout from '@/components/layout/Layout.vue'
import { getAdvertiserWechatApplets, pullWechatApp } from '@/api/advertiser'
import SyncCostForm from '@/views/sys/advertiser/sync-cost/SyncCost.vue'
import CreateAppForm from '@/views/sys/advertiser/create-app/CreateApp.vue'

export default {
    components: {
        Layout,
        SyncCostForm,
        CreateAppForm
    },
    props: {
        showWechatAppForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            data: [],
            pagination: { defaultPageSize: 20 },
            loading: false,
            columns: [
                { title: '小程序资产ID', dataIndex: 'instance_id' },
                { title: '小程序类型', dataIndex: 'type', customRender: type => {
                    return type === 2 ? '字节' : '微信'
                }  },
                { title: '小程序名称', dataIndex: 'name' },
                { title: '资产备注', dataIndex: 'remark_message' },
                { title: '小程序id', dataIndex: 'user_name' },
                { title: '小程序路径', dataIndex: 'path' },
                { title: '链接id', dataIndex: 'link_id' },
                { title: '审核状态', dataIndex: 'audit_status', scopedSlots: { customRender: 'audit_status' }  },
                { title: '创建时间', dataIndex: 'create_time' },
            ],
            queryParam: {},
            showSyncCostForm: false,
            showAppForm: false,
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        handleTableChange(pagination) {
            const pager = { ...this.pagination }
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            const pagination = { ...this.pagination }
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize,
                id: this.model.id,
            })
            this.$helper.buildDateRangeParams(json, 'date')
            getAdvertiserWechatApplets(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.pagination.current = 1
            this.getData()
        },
        close() {
            this.$emit('update:showWechatAppForm', false)
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('AdvertiserController', route)
        },
        pullWechatApp(type) {
            const json = {
                ids: [this.model.id],
                type: type
            }
            pullWechatApp(json).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('拉取成功')
                    this.pagination.current = 1
                    this.getData()
                } else {
                    this.$message.error('拉取失败')
                }
            }).catch(() => {
                this.$message.error('拉取失败')
            })
        },
        createApp() {
            this.model.type = 1
            this.model = Object.assign({}, this.model)
            this.model.ids = this.model.id
            this.showAppForm = true
        },
    
    }
}
